import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    direction: 'ltr',
    maxWidth: theme.spacing(650),
    margin: '0 auto',
    padding: '0 30px',
    marginBottom: 60,

    '& p': {
      textAlign: 'justify',
      paddingTop: theme.spacing(5),
    },
  },
  boldFont: {
    fontWeight: 700,
  },
  header: {
    backgroundColor: '#212121',
    textAlign: 'center',
    color: '#fff',
    padding: theme.spacing(30, 10),
    marginBottom: theme.spacing(20),
  },
  headerTitle: {
    fontSize: theme.spacing(24),
    lineHeight: theme.spacing(40) + 'px',
    fontWeight: theme.spacing(400),
    color: '#fff',
  },
  headerSubtitle: {
    color: '#fff',
    fontSize: theme.spacing(8),
    fontWeight: theme.spacing(250),
  },
  title: {
    fontSize: theme.spacing(10),
    color: '#212121',
    fontWeight: theme.spacing(350),
    display: 'inline-flex',
  },
  termsTopic: {
    margin: theme.spacing(5, 0, 7.5),

    '& > div': {
      paddingLeft: theme.spacing(10),
    },
    '& ul > li::marker': {
      fontSize: theme.spacing(12),
    },
  },
}));
